import { defineMessages } from 'react-intl';

/** The copy of the Composer media picker ("Attach media"). */
export const pickerMessages = defineMessages({
  title: { id: 'app.sml.promote.composer.picker.title', defaultMessage: 'Attach media' },
  song: { id: 'app.sml.promote.composer.picker.song', defaultMessage: 'Song' },
  songNone: { id: 'app.sml.promote.composer.picker.song.none', defaultMessage: 'Pick a song' },
  filterLabel: { id: 'app.sml.promote.composer.picker.filter.label', defaultMessage: 'Show' },
  filterAll: { id: 'app.sml.promote.composer.picker.filter.all', defaultMessage: 'All' },
  filterImages: { id: 'app.sml.promote.composer.picker.filter.images', defaultMessage: 'Images' },
  filterVideos: { id: 'app.sml.promote.composer.picker.filter.videos', defaultMessage: 'Videos' },
  handover: { id: 'app.sml.promote.composer.picker.handover', defaultMessage: 'Handed over' },
  yourUploads: { id: 'app.sml.promote.composer.picker.yourUploads', defaultMessage: 'Your uploads' },
  uploadNoName: { id: 'app.sml.promote.composer.picker.uploadNoName', defaultMessage: 'Your file' },
  revision: { id: 'app.sml.promote.composer.picker.revision', defaultMessage: 'r{revision}' },
  attach: { id: 'app.sml.promote.composer.picker.attach', defaultMessage: 'Attach' },
  cancel: { id: 'app.sml.promote.composer.picker.cancel', defaultMessage: 'Cancel' },
  openStudio: { id: 'app.sml.promote.composer.attach.empty.action', defaultMessage: 'Open the Studio' },
  emptyTitle: { id: 'app.sml.promote.composer.picker.empty.title', defaultMessage: 'Nothing ready for this song' },
  emptyBody: {
    id: 'app.sml.promote.composer.picker.empty.body',
    defaultMessage: 'Make an image or a video in the Studio, then attach it here.',
  },
  noSongTitle: { id: 'app.sml.promote.composer.picker.noSong.title', defaultMessage: 'Nothing made yet' },
  noSongBody: {
    id: 'app.sml.promote.composer.picker.noSong.body',
    defaultMessage: 'Pick a song above, make an image or a video in the Studio, or upload a file.',
  },
  noImages: { id: 'app.sml.promote.composer.picker.filter.noImages', defaultMessage: 'No images for this song.' },
  noVideos: { id: 'app.sml.promote.composer.picker.filter.noVideos', defaultMessage: 'No videos for this song.' },
  upload: { id: 'app.sml.promote.composer.picker.upload.device', defaultMessage: 'Upload from your device' },
  uploadHint: {
    id: 'app.sml.promote.composer.picker.upload.device.hint',
    defaultMessage: 'Images: JPG, PNG or WebP, up to 25 MB. Videos: MP4 or MOV, up to 1 GB.',
  },
  uploading: { id: 'app.sml.promote.composer.picker.upload.uploading', defaultMessage: 'Uploading {name}' },
  uploadingVideo: {
    id: 'app.sml.promote.composer.picker.upload.uploadingVideo',
    defaultMessage: 'Uploading {name}: {percent}%',
  },
  checkingVideo: {
    id: 'app.sml.promote.composer.picker.upload.checkingVideo',
    defaultMessage: 'Checking {name}',
  },
  stop: { id: 'app.sml.promote.composer.picker.upload.stop', defaultMessage: 'Stop' },
  retry: { id: 'app.sml.promote.composer.picker.upload.retry', defaultMessage: 'Try again' },
  refusedType: {
    id: 'app.sml.promote.composer.picker.upload.refused.anyType',
    defaultMessage: '{name} is not a JPG, PNG or WebP image, or an MP4 or MOV video.',
  },
  refusedSize: {
    id: 'app.sml.promote.composer.picker.upload.refused.size',
    defaultMessage: '{name} is larger than 25 MB.',
  },
  refusedVideoSize: {
    id: 'app.sml.promote.composer.picker.upload.refused.videoSize',
    defaultMessage: '{name} is larger than 1 GB.',
  },
  failed: {
    id: 'app.sml.promote.composer.picker.upload.failed',
    defaultMessage: '{name} did not upload. Try again.',
  },
  // The server limits the video uploads (429): starts in an hour, and uploads that did not finish.
  limitReached: {
    id: 'app.sml.promote.composer.picker.upload.limitReached',
    defaultMessage: '{name} did not upload: you started many video uploads. Wait a moment, then try again.',
  },
  // The server could not read the video (ffprobe), so it refused it.
  unreadable: {
    id: 'app.sml.promote.composer.picker.upload.unreadable',
    defaultMessage: 'We could not read {name}. Export it again as an MP4 (H.264) or a MOV file and upload it again.',
  },
});
